import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import { PENDING_CERTS_QUERY_KEY } from "@/hooks/queries/useListPendingLegacyCerts";
import type { ApprovedCertData } from "@/hooks/queries/admin-legacy-cert-types";

// POST /admin/legacy-certs/{id}/approve (Story 16.4, AC11) — super_admin approves a
// pending cert. On success the pending-queue query is invalidated so the decided row
// leaves the queue (AC9). A post-session call, so it rides apiFetch's silent-refresh
// path (skipAuthRefresh omitted). The approval flips cert_verified via a domain event
// server-side — it does NOT enable the account (is_active stays false, FR39).

export function useApproveLegacyCert() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (certId: string) =>
      apiFetch<ApprovedCertData>(`/admin/legacy-certs/${certId}/approve`, {
        method: "POST",
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: PENDING_CERTS_QUERY_KEY });
    },
  });
}
